export const enColumnsPageTranslations = {
  ColumnsPage: {
    title: 'Columns',
    subtitle: 'Extra columns for the patient list in this organization.',
    tabsLabel: 'Cohorts and columns',
    cohortsTab: 'Cohorts',
    columnsTab: 'Columns',
    published: 'Published',
    loading: 'Loading columns',
    empty: 'No columns yet.',
    loadFailed: 'Could not load columns.',
    notEnabled: "Computed columns aren't turned on for this organization.",
    retry: 'Try again',
    close: 'Close',
    cancel: 'Cancel',
    newColumn: 'New column',
    edit: 'Edit',
    editColumnLabel: 'Edit {{name}}',
    delete: 'Delete',
    deleteColumnLabel: 'Delete {{name}}',
    valueKind: {
      numberDays: 'A number, in days',
      numberWhole: 'A whole number',
      numberPercent: 'A percentage',
      number: 'A number',
      date: 'A date',
      dateTime: 'A date and time',
      text: 'Text',
      option: 'One of a list of options',
    },
    usedBy_one: 'Used by {{count}} view',
    usedBy_other: 'Used by {{count}} views',
    hiddenViewsUse_one: '{{count}} view you can’t see uses it',
    hiddenViewsUse_other: '{{count}} views you can’t see use it',
    notUsed: 'Not used by any view',
    shownOnPatientPage: 'Shown on the patient page',
    setupChat: {
      workspaceUnreachable: 'This column is in a workspace you can’t switch to.',
      unavailable: 'The setup chat isn’t available here right now.',
    },
    deleteDialog: {
      title: 'Delete “{{name}}”?',
      description: 'Delete the selected column.',
      checkingUsage: 'Checking…',
      usageFailed: 'Could not check where this column is used.',
      usageNotFound: 'This column no longer exists.',
      confirm: 'Delete column',
      effect: 'The column is removed from the patient list. No view uses it.',
      patientPageNote: 'It is also removed from the patient page.',
      usedByHeading: 'These views use this column. Remove it from them first:',
      dependentsHeading: 'These also use this column. Update them first:',
      hiddenDependents_one: '{{count}} more you don’t have access to',
      hiddenDependents_other: '{{count}} more you don’t have access to',
      hiddenDependents_named_one: '{{count}} more you don’t have access to',
      hiddenDependents_named_other: '{{count}} more you don’t have access to',
      view: 'View “{{name}}”',
      viewOtherWorkspace: 'View “{{name}}” in another workspace',
      viewSortedBy: '(sorted by it)',
      viewFilteredBy: '(filtered by it)',
      hiddenViews_one: '{{count}} view you can’t see uses this column',
      hiddenViews_other: '{{count}} views you can’t see use this column',
      hiddenViews_named_one: '{{count}} other view you can’t see also uses this column',
      hiddenViews_named_other: '{{count}} other views you can’t see also use this column',
      customerApiNote:
        'Deleting a column also removes it for anyone reading it through the customer API.',
      deleted: 'Deleted {{name}}.',
    },
    patientPage: {
      title: 'Shown on the patient page',
      description:
        'Choose which columns appear on each patient’s page, and in what order. Up to 10.',
      sourceOrganization: 'This workspace uses the organization’s list.',
      sourceWorkspace: 'This workspace has its own list.',
      emptyList: 'No columns are shown on the patient page.',
      loading: 'Loading the patient page columns',
      loadFailed: 'Could not load the patient page columns.',
      listChoiceLabel: 'List to change',
      organizationList: 'Organization list',
      thisWorkspace: 'This workspace',
      organizationListNote: 'Every workspace without its own list uses this one.',
      usesOrganizationList: 'Uses the organization’s list',
      startOwnList: 'Use a different list for this workspace',
      goBack: 'Go back to the organization’s list',
      add: 'Add a column…',
      capReached: 'Up to {{max}} columns',
      unavailableColumn: 'A column that is no longer available',
      remove: 'Remove',
      removeColumnLabel: 'Remove {{name}}',
      moveUpLabel: 'Move {{name}} up',
      moveDownLabel: 'Move {{name}} down',
      save: 'Save',
      saved: 'Saved the patient page columns.',
      wentBack: 'This workspace now uses the organization’s list.',
      goBackDialog: {
        title: 'Go back to the organization’s list?',
        description: 'Stop using this workspace’s own list.',
        body: 'This workspace’s own list is removed. It shows the organization’s list instead.',
        confirm: 'Go back',
      },
      errors: {
        generic: 'Could not save the list. Try again.',
        removeFailed: 'Could not go back to the organization’s list. Try again.',
        notAllowed: 'Only OneStep staff can change this list.',
        notEnabled: 'This is not available for your organization.',
        unknownColumn: 'A column in this list can no longer be used. Remove it and save again.',
        unknownColumnNamed_one: '{{names}} is not available in this workspace.',
        unknownColumnNamed_other: '{{names}} are not available in this workspace.',
        unavailableColumnInline: 'a column that is no longer available',
        nameList: '{{names}} and {{last}}',
        workspaceColumnInOrganizationList:
          'A column that belongs to one workspace can’t be in the organization’s list.',
        workspaceColumnInOrganizationListNamed_one:
          '{{names}} belongs to one workspace, so it can’t be in the organization’s list.',
        workspaceColumnInOrganizationListNamed_other:
          '{{names}} belong to one workspace, so they can’t be in the organization’s list.',
        duplicateColumn: 'A column is in the list twice. Remove one and save again.',
        duplicateColumnNamed_one: '{{names}} is in the list twice. Remove one and save again.',
        duplicateColumnNamed_other:
          '{{names}} are in the list twice. Remove the extras and save again.',
        tooManyColumns: 'A list can show up to {{max}} columns.',
      },
    },
    errors: {
      generic: 'Could not delete the column. Try again.',
      inUse: 'A view still uses this column. Remove it from the views first.',
      notAllowed: 'Only OneStep staff can delete columns.',
      notFound: 'This column no longer exists. The list has been refreshed.',
      revisionConflict: 'This column was changed by someone else. The list has been refreshed.',
    },
  },
};
